import React, { useState } from 'react';
import { makeStyles,  Typography, Button, Select, InputLabel, MenuItem, FormControl, Input } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import {passwordService} from '../../Services/passwordService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



export default function PasswordDialog(props) {
    const classes = useStyles();
    const [ClientId, setClientId] = useState(0)
    const [clientSelected, setSelectedClient] = useState(false)
    const [passwordFilled, setPasswordFilled] = useState(false);
    const [hashed, setHash] = useState();
    const [isHashed, setHashed] = useState(false);

    const [password, setPassword] = useState();

    toast.configure();

    const changeSelectedClient = (event) => {
        setSelectedClient(true);
        setClientId(event.target.value)
    }

    const handleGenerate = (id) => {
        passwordService.getPassword(id, password).then(response => {
                    navigator.clipboard.writeText(response);
                    setHash(response);
                    setHashed(true);
                    toast.success('Password copied to clipboard', {position: toast.POSITION.TOP_CENTER});
        }).catch((error) => {toast.error(error, {position: toast.POSITION.TOP_CENTER})});
    };

    const passwordChanged = (event) =>{
        setPassword(event.target.value);
        if((event.target.value).length > 0){
            setPasswordFilled(true)
        }    
    }
    
    return <Dialog onClose={props.handleClose} aria-labelledby="customized-dialog-title" open={props.open}>
                <DialogContent dividers>
                <Button className={classes.closeButton} onClick={props.handleClose}><CloseIcon></CloseIcon></Button>

                    <div className={classes.dialog}>
                        <Typography className={classes.formTitle}>Generate password</Typography>
                        <div className={classes.clientDropdown}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Client</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    className={classes.selectField}
                                    value={ClientId}
                                    label="Client"
                                    onChange={(e) => changeSelectedClient(e)}>
                                    {props.clients.map(x => {
                                        return (
                                                <MenuItem key={x.id} value={x.id} name={x.clientName}>{x.clientName}</MenuItem>)
                                        })}
                                </Select>
                            </FormControl>
                        </div>
                        <div className={classes.passwordForm}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="my-input">Password</InputLabel>
                            <Input fullWidth type="password" onChange={(x) => passwordChanged(x)} value={password}  label="Password" />
                        </FormControl>
                        </div>
                        <div className={classes.hashedForm}>
                        <FormControl fullWidth>
                        <InputLabel htmlFor="my-input">Hashed Password</InputLabel>

                            <Input fullWidth type="text" disabled='disabled' value={isHashed === true ? hashed : ' '}  label="Hashed password" />
                        </FormControl>
                        </div>
                        <div className={classes.buttonContainer}>
                            <Button className={classes.backButton} autoFocus variant="outlined" onClick={props.handleClose} color="primary">
                                Cancel
                            </Button>
                            <Button className={classes.generateButton} disabled={!clientSelected && !passwordFilled} variant="contained" onClick={() => handleGenerate(ClientId)} color="primary">
                                Generate
                            </Button>
                        </div>
                </div>
                </DialogContent>
            </Dialog>
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px'  
      },
      closeButton: {
        float: 'right',
      },
      buttonContainer:{
        display: 'flex',
        justifyContent: 'center',
      },
  
      paper: {
          padding: '50px',
          margin: "50px",
          height: '70%'
      },
      clientDropdown: {
        width: '100%',
      },
      passwordForm:{
        marginTop: '20px',
      },
      hashedForm: {
        marginTop: '20px',
      },
      dialog: {
          width: '250px',
          marginLeft: "60px",
          marginRight: "60px",
          justifyContent: "center",
          textAlign: "center"
      },
      formTitle: {
          marginBottom: "10px",
          fontSize: "20pt"
      },
      deleteTexsmall: {
          fontSize: "14pt"
      },
      backButton: {
          margin: '10px'
      },
      generateButton: {
          margin: '10px',
          backgroundColor: "#28a745!important"
      }
});